import { createApi, } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const additionalInfoApi = createApi({
    reducerPath: "additionalInfoApi",
    baseQuery,
    tagTypes: ["AdditionalInfo"],
    endpoints: (builder) => ({

        getAdditionalInfoById: builder.query({
            query: ({id} ) => `/export/product/additionalInfo/${id}`,
            transformResponse: (response) => {
              const data = response?.data ?? [];
              const normalized = Array.isArray(data) ? data : [data];
      
              return normalized.map((item) => ({
                ...item,
                id: item.additionalInfoId, 
              }));
            },
            providesTags: ["AdditionalInfo"],
          }),

        createAdditionalInfo: builder.mutation({
            query: ({id  , ...data}) => ({
              url: `/export/product/additionalInfo/${id}`,
              method: "PUT", 
              body: { additionalInfo:data },
              headers: {
                "X-Request-Id":`${Date.now()}`,
              },
            }),
            invalidatesTags: ["AdditionalInfo"],
          }),

          updateAdditionalInfo: builder.mutation({
            query: ({ id ,subId, ...data  }) => ({
              url: `/export/product/additionalInfo/${id}/${subId}`,
              method: "PUT",
              body: { additionalInfo:data},
              headers: {
                "X-Request-Id":`${Date.now()}`,
              },
            }),
            invalidatesTags: ["AdditionalInfo"],
          }),

          deleteAdditionalInfo: builder.mutation({
            query: ({ id }) => ({
              url: `/export/product/additionalInfo/${id}`,
              method: "DELETE",
              headers: {
                "X-Request-Id":`${Date.now()}`, 
              },
            }),
            invalidatesTags: ["AdditionalInfo"],
          }),
    }),
});

export const {
    useLazyGetAdditionalInfoByIdQuery,
    useCreateAdditionalInfoMutation,
    useUpdateAdditionalInfoMutation,
    useDeleteAdditionalInfoMutation,
} = additionalInfoApi;
